export const appRunBlock = [   "$rootScope","$http","$q","$injector","$timeout","$oeuvresHandler","$location","$state","dragHandlesService","contextMenuService","$ApiHandler","$uibModal","artestUserBarService","$User","Notification", "modalOpenerGenerator","$templateCache","commentHandlersService",
function( $rootScope,  $http,  $q,  $injector,  $timeout,  $oeuvresHandler,  $location,  $state,  dragHandlesService,  contextMenuService,  $ApiHandler,  $uibModal,  artestUserBarService,  $User,  Notification,   modalOpenerGenerator,  $templateCache, commentHandlersService ) {

	var $ready = $rootScope.__$ready = $q.defer();

	window.$rootScope = $rootScope;
	window.Notification = Notification;

	$rootScope.DEBUG = window.DEBUG = !!((window.DEBUG == null) ? $User.classes["AA000000000002A7"] : window.DEBUG);

	$rootScope.loading = true;

	$rootScope.$state = $state;

	$rootScope.injector = window.injector = function(){ return $injector.get(arguments[0]); };

	$rootScope.$users_assets = (function( mappings ){
		return function( user_uid ){
			if( !mappings[ user_uid ]){
				$ApiHandler.get("/users/"+user_uid, {
					filters: "asarray,onlydata,onlyattrs"
				}).then(function(user){
					debugger;
				});
			}
			return mappings[ user_uid ] || user_uid;
		};
	})($rootScope.$users_names_mappings = {});

	/*********************/

	if (window.DEBUG) ([
		[ "$stateChangeStart" ],
		[ "$stateChangeSuccess" ],
		[ "$stateNotFound" ],
		[ "$stateChangeError" ],

		[ "onControlModeVisibilityChanged", "gameService.inControlMode" ],
		[ "spherical360SetupServiceEnabled" ],
		[ "spherical360SetupServiceDisabled" ],
		[ "editorEnabled" ],
		[ "editorDisabled" ],
		[ "hilightChanged" ]
	]).forEach(function( v ) {
		var str = "$("+ v[0] +")";
		if (v[1]) str += " :: " + v[1] + " =";

		$rootScope.$on( v[0], function( event ) {
			console.debug.apply( console, [ str ].concat( Array.prototype.slice.call( arguments, 1 )) );
		});
	});

	/*********************/

	$rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams, options){

		// Varmistetaan, että jos ollaan jo 3D-tilassa, ei mene sommitelmat sotkuun
		if (toState.name == "scene" && fromState.name == "scene") {
			if (toParams.arrangement_uid != fromParams.arrangement_uid) {
				location.reload();
			}
		}

		$rootScope.loading = true;
	});

	$rootScope.$on('$stateChangeError', function( event, toState, toParams, fromState, fromParams, error ){

		var params = {}

		if (toParams.arrangement_uid) {
			params.arrangement_uid = toParams.arrangement_uid;
		}

		try {
			$state.go( "arrangements", params );
		} catch (err) {
			$state.go( "404", params );
		}

		try {
			if (window.WELCOME_MODAL && window.WELCOME_MODAL.result.$$state.status == 0) {
				window.WELCOME_MODAL.close();
			}
		} catch (err) { }
	});

	/*********************/

	$rootScope.openAccessControlsModal = (function( openAccessControlsModal ) {
		return function( arrangement, model ) {

			model = arrangement && arrangement.$model || model;

			return openAccessControlsModal( arrangement || null, model || null );
		};
	})( modalOpenerGenerator.generate( "access-controls", { controllerBasepath: location.origin + "/model-preview/js/controllers/" }, [ "arrangement", "model" ]));

	$rootScope.openOeuvreImporterModal      = modalOpenerGenerator.generate( "oeuvres-importer",     { templateUrl: "/ajax/cms/partials/modal.oeuvres-importer.html", controllerBasepath: "/libs/cms/controllers/", size: "lg" }, [ "selectedOeuvres" ]);
	$rootScope.openModelCreatorModal        = modalOpenerGenerator.generate( "model-creator",        { controllerBasepath: location.origin + "/model-preview/js/controllers/" }, [ ]);
	$rootScope.openModelSettingsModal       = modalOpenerGenerator.generate( "model-settings",       { controllerBasepath: location.origin + "/model-preview/js/controllers/" }, [ "model" ]);
	$rootScope.openArrangementSettingsModal = modalOpenerGenerator.generate( "arrangement-settings", { controllerBasepath: location.origin + "/model-preview/js/controllers/" }, [ "arrangement" ]);
	$rootScope.openPlayerSettingsModal      = modalOpenerGenerator.generate( "player-settings",      { controllerBasepath: location.origin + "/model-preview/js/controllers/", size: "lg" }, [ ]);

	$rootScope.openArtestFileGalleryModal = (function(){
		var inited = false;
		/* /cmsengine/js/artestFileGallery.js */
		var elem;
		return function( successcallback, errorcallback, options, extraargs ){
			var prms = $q.defer();

			if (inited) prms.resolve();
			else {
				$q.all([
					jQuery.getScript( "/libs/node_modules/isteven-angular-multiselect/isteven-multi-select.js" ).then(eval),
					jQuery.getScript( "/dashboard/js/directives.js"                                            ).then(eval),
					jQuery.getScript( "/cmsengine/js/artestFileGallery.js"                                     ).then(eval)
				]).then(function() {
//					elem = $("body").append("")document.create
//					debugger;

//					angular.element(function(){
//						angular.bootstrap(document, [ 'cmsEngine.artestFileGallery' ]);
//					});						
				}).then( prms.resolve ).catch( prms.reject );
			}
			
			return prms.promise.then(function(){
//				inited = true;
//				debugger;
			}).catch(function( error ){
				console.error( error );
				throw error;
			});
		};
	})();
}];